import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * It is used to delete temparory basket if exist
 */
export const deleteTempBasket = async (getTokenWhenReady, basket) => {
    const basketId = basket?.basketId
    const {app} = getConfig()
    const {organizationId, siteId} = app.commerceAPI.parameters
    try {
        const token = await getTokenWhenReady()
        if (!token) {
            console.log('token is not generated to create temp basket')
            return null
        }
        const apiUrl = `${getAppOrigin()}/mobify/proxy/api/checkout/shopper-baskets/v2/organizations/${organizationId}/baskets/${basketId}?siteId=${siteId}`
        const deleteBasket = await fetch(apiUrl, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }).then((res) => {
            if (!res.ok && res.status !== 204) {
                return null
            }
        })

        return deleteBasket
    } catch (error) {
        console.log('getTempBasket: exception occured', error.message)
    }
}
